import { TABLE_HEADER_SUBTEXT } from '../../../../../constants/commonConstants';
import {
  DateFiltering,
  DateSorting,
  OppsNameSorting,
  QuarterYearSorting,
} from '../../../../../util/commonFunctions';
import '../../../gcsp/styles/styles.css';

const aggFunc = params => {
  if (params.rowNode.groupData['ag-Grid-AutoColumn'] !== 'Missed') {
    if (params.values.length !== 0) {
      const sum = params.values.reduce((acc, val) => acc + Number(val));
      return sum + Number(0);
    }
  } else {
    return;
  }
};

const menuTabsItems = ['filterMenuTab'];

const cellTextAligment = { display: 'flex', justifyContent: 'flex-end' };

export const columnDefsKeys = [
  {
    headerName: 'PL Commit Status',
    field: 'category',
    cellRenderer: 'commitColumnRenderer',
    width: 150,
    rowGroup: true,
    hide: true,
    suppressMovable: true,
  },
  {
    headerName: 'ID',
    field: 'ey_id',
    width: 120,
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    suppressMovable: true,
  },
  {
    headerName: 'Opportunity Name',
    field: 'opportunityname',
    sortable: true,
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    cellRenderer: 'textLinkRenderer',
    width: 240,
    suppressMovable: true,
    comparator: OppsNameSorting,
  },
  {
    headerName: 'Comment',
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    cellRenderer: 'commentColumnRenderer',
    cellRendererParams: { innerRenderer: 'commentColumnRenderer' },
    width: 100,
    suppressMovable: true,
  },

  {
    headerName: 'AWD',
    field: 'AWD',
    sortable: true,
    menuTabs: menuTabsItems,
    filter: 'agDateColumnFilter',
    filterParams: DateFiltering,
    cellRenderer: 'awd_Field_Rendere',
    headerComponentParams: {
      enableSorting: true,
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
    },
    width: 200,
    comparator: DateSorting,
    suppressMovable: true,
  },
  {
    headerName: 'Prob.(%)',
    field: 'Prob',
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    cellRenderer: 'probCellRenderer',
    width: 130,
    suppressMovable: true,
  },
  {
    headerName: 'Pursuit Leader',
    field: 'PursuitLeader',
    menuTabs: menuTabsItems,
    filter: 'agTextColumnFilter',
    width: 200,
    suppressMovable: true,
  },
  {
    headerName: 'Assurance',
    field: 'Assurance',
    sortable: true,
    headerComponentParams: {
      displayName: 'Assurance',
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.EXCL_ACR,
    },
    width: 165,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer',
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'Consulting',
    field: 'consulting',
    sortable: true,
    headerComponentParams: {
      displayName: 'Consulting',
      enableSorting: true,
    },
    width: 165,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer',
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'SAT',
    field: 'sat',
    sortable: true,
    headerComponentParams: {
      displayName: 'SAT',
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.EXCL_ITTS,
    },
    width: 165,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer',
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'Tax',
    field: 'tax',
    sortable: true,
    headerComponentParams: {
      displayName: 'Tax',
      enableSorting: true,
      subText: TABLE_HEADER_SUBTEXT.EXCL_ITTS,
    },
    width: 165,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer',
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'ITTS',
    field: 'itts',
    // sortable: true,
    headerComponentParams: { displayName: 'ITTS', enableSorting: true },
    width: 165,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer',
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'EMEIA ACR',
    field: 'EMIAACR',
    sortable: true,
    headerComponentParams: { displayName: 'EMEIA ACR', enableSorting: true },
    width: 165,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer',
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
  {
    headerName: 'TOV',
    field: 'TOV',
    sortable: true,
    headerComponentParams: { displayName: 'TOV', enableSorting: true },
    width: 180,
    cellStyle: cellTextAligment,
    cellRenderer: 'serviceLineCelRenderer',
    aggFunc: aggFunc,
    suppressMenu: true,
    suppressMovable: true,
  },
];
